import React, { FunctionComponent } from 'react';
import styled, { css } from 'styled-components';
import { CoursesByName } from './CoursesByName';

interface IListCourses {
  data?: {
    content: {
      order_lesson: string;
      body: [];
      preview_title: string;
      preview_image: {
        filename: string;
        alt: string;
      };
      percentComplete?: string;
      category: string;
    };
    uuid: string;
    full_slug: string;
    id: number;
  }[];
  lessonsWithProgress?:
    | {
        lessonId: number;
        completionPercents: number;
      }[]
    | [];
  learningContent?: boolean;
  setShow?: boolean;
}

export const ListCourses: FunctionComponent<IListCourses> = ({
  data,
  lessonsWithProgress,
  learningContent,
}) => {
  const dataInProgress =
    lessonsWithProgress &&
    data
      .filter((el) =>
        lessonsWithProgress.map((id) => id.lessonId).includes(el.id),
      )
      .sort(
        (a, b) =>
          Number(a.content.order_lesson) - Number(b.content.order_lesson),
      );

  const dataTheEarth = data
    .filter((el) => el.content.category === 'earth')
    .sort(
      (a, b) => Number(a.content.order_lesson) - Number(b.content.order_lesson),
    );
  const dataChangeMakers = data
    .filter((el) => el.content.category === 'change-makers')
    .sort(
      (a, b) => Number(a.content.order_lesson) - Number(b.content.order_lesson),
    );
  const dataRealWorldSkills = data
    .filter((el) => el.content.category === 'real-skills')
    .sort(
      (a, b) => Number(a.content.order_lesson) - Number(b.content.order_lesson),
    );

  return (
    <ListCoursesWrapper learningContent={learningContent}>
      {lessonsWithProgress && dataInProgress.length > 0 && (
        <CoursesByName
          title="IN PROGRESS"
          data={dataInProgress}
          lessonsWithProgress={lessonsWithProgress}
          zIndex={11}
        />
      )}
      {dataTheEarth.length > 0 && (
        <CoursesByName
          title="THE EARTH"
          data={dataTheEarth}
          learningContent={learningContent}
          zIndex={10}
        />
      )}
      {dataChangeMakers.length > 0 && (
        <CoursesByName
          title="CHANGE-MAKERS"
          data={dataChangeMakers}
          learningContent={learningContent}
          zIndex={9}
        />
      )}
      {dataRealWorldSkills.length > 0 && (
        <CoursesByName
          title="REAL-WORLD SKILLS"
          data={dataRealWorldSkills}
          learningContent={learningContent}
          zIndex={8}
        />
      )}
    </ListCoursesWrapper>
  );
};
interface IListCoursesWrapper {
  learningContent?: boolean;
}
const ListCoursesWrapper = styled.div<IListCoursesWrapper>`
  ${({ learningContent, theme: { Consts } }) => css`
    display: flex;
    flex-direction: column;
    gap: 56px;
    padding: ${learningContent ? '0px 147px 0' : '53px 147px 134px'};
    max-width: 100vw;
    width: 100%;
    overflow: visible;
    @media (max-width: ${Consts.mobileBreakPoint}) {
      padding: ${learningContent ? '25px 20px 0' : '40px 20px 0'};
      gap: 40px;
    }
  `}
`;
